import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditCourseForCandidateResponse extends BackendResponse {}
export interface EditCourseForCandidateParameters extends NextApiParams {
  courseId: number;
  from: string;
  to: string;
  candidateId: number;
  organizer: string;
  courseType: number;
  references: string;
  comment: string;
  level: number;
  expirationDate: string;
  duplicateCheck: boolean;
}

export const editCourseForCandidate = withNextApi<
  EditCourseForCandidateResponse,
  EditCourseForCandidateParameters
>("/cvp/CvpEditCourseForCandidate");
